import { VAT_MODES, VAT_MODE_LABELS_RU, type VatMode } from '@crm/shared'

const HINTS: Record<VatMode, string> = {
  INCLUDED: 'Цены в КП с НДС 22%, в итоге «в том числе НДС» — как раньше.',
  ON_TOP:
    'Цены в КП без НДС (до копейки), НДС 22% начисляется сверху — как в заказе 1С:УНФ «НДС сверху». Счёт по этому КП будет тоже «НДС сверху».',
}

/**
 * Переключатель показан менеджерам? Решение 15.10.2026 (звонок с Павлом): пока скрыт — простота,
 * к «НДС сверху» в КП вернёмся позже. Скрыт — новые КП «С НДС», как до ветки. Включить — true.
 * Счета «НДС сверху» из 1С загружаются независимо от флага (docs/features/kp-vat-mode.md).
 */
export const KP_VAT_TOGGLE_ENABLED = false

/**
 * Переключатель режима НДС КП (паспорт docs/features/kp-vat-mode.md): в панели режима КП и в
 * предпросмотре. По умолчанию — режим прошлого КП заявки, у первого КП — «С НДС».
 */
export function KpVatModeToggle({
  value,
  onChange,
}: {
  value: VatMode
  onChange: (mode: VatMode) => void
}) {
  return (
    <div className="flex items-center gap-2" title={HINTS[value]}>
      <span className="text-xs font-medium text-gray-600">НДС</span>
      <div
        role="radiogroup"
        aria-label="Режим НДС в КП"
        className="inline-flex rounded-lg border border-gray-300 bg-white p-0.5"
      >
        {VAT_MODES.map((mode) => {
          const active = mode === value
          return (
            <button
              key={mode}
              type="button"
              role="radio"
              aria-checked={active}
              onClick={() => onChange(mode)}
              title={HINTS[mode]}
              className={`px-2.5 py-0.5 text-xs font-medium rounded-md transition-colors ${
                active ? 'bg-brand-600 text-white' : 'text-gray-600 hover:bg-gray-50'
              }`}
            >
              {VAT_MODE_LABELS_RU[mode]}
            </button>
          )
        })}
      </div>
    </div>
  )
}
